import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Users|Email History|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: true,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};
const columnDescriptionStart = 'Column heading for: ';

type LocNameStart = 'SPUserEmailHistoryTable';
export type SPUserEmailHistoryTableLocNames =
	| `${LocNameStart}ButtonCatalogView`
	| `${LocNameStart}LabelCompleted`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelCatalogLink`;

export const spUserEmailHistoryTableLocs: LocDefs<SPUserEmailHistoryTableLocNames> = {
	SPUserEmailHistoryTableButtonCatalogView: {
		defaultValue: 'View',
		description: 'Button to view the catalog item.',
		displayPath: `${pathStart}View`,
		displayType: 'Button',
		legacyName: 'Core/Users.EmailHistory.Button.CatalogLink',
		...sharedProperties,
	},
	SPUserEmailHistoryTableLabelCompleted: {
		defaultValue: 'Completed',
		description: `${columnDescriptionStart}Completed`,
		displayPath: `${pathStart}Completed`,
		displayType: 'Label',
		legacyName: 'Core/Users.EmailHistory.ColumnHeading.Completed',
		...sharedProperties,
	},
	SPUserEmailHistoryTableLabelType: {
		defaultValue: 'Type',
		description: `${columnDescriptionStart}Type`,
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'Core/Users.EmailHistory.ColumnHeading.Type',
		...sharedProperties,
	},
	SPUserEmailHistoryTableLabelStatus: {
		defaultValue: 'Status',
		description: `${columnDescriptionStart}Status`,
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'Core/Users.EmailHistory.ColumnHeading.Status',
		...sharedProperties,
	},
	SPUserEmailHistoryTableLabelCatalogLink: {
		defaultValue: 'Email Catalog',
		description: `${columnDescriptionStart}Email Catalog`,
		displayPath: `${pathStart}Email Catalog`,
		displayType: 'Label',
		legacyName: 'Core/Users.EmailHistory.ColumnHeading.CatalogLink',
		...sharedProperties,
	},
};

export type SPUserEmailHistoryTableLocType = LocMap<SPUserEmailHistoryTableLocNames>;
